var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',[_c('v-list-item-content',[_c('v-text-field',{ref:"searchInput",attrs:{"data-name":"filter-popup-search","label":_vm.$t('ui.input-select.search'),"value":_vm.value,"filled":"","hide-details":"","dense":"","append-icon":"mdi-magnify"},on:{"input":(e) => _vm.$emit('input', e)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }